import React from "react";
import styles from "./Intro.module.less";

export interface Props {
    content: string;
}

export default function Intro(props: Props) {
    return (
        <div className={styles["Intro"]} dangerouslySetInnerHTML={{ __html: props.content }} />
    );
}
